module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.site.latitude && _vm.site.longitude) ? _c('div', [_c('google-map', {
    attrs: {
      "lat": _vm.site.latitude,
      "lng": _vm.site.longitude,
      "zoom": 16,
      "type": "hybrid"
    }
  })], 1) : _c('div', [_c('h3', [_vm._v("No mapping data found")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "14px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.site.siteName) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.site.siteName))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.site.siteId))]), _vm._v(" \n          "), (_vm.site.subdistrict) ? _c('span', [_c('i', [_vm._v("| " + _vm._s(_vm.site.subdistrict))]), _vm._v(" "), (_vm.site.district) ? _c('i', [(_vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.district))]) : _vm._e(), _vm._v(" "), (_vm.site.region) ? _c('i', [(_vm.site.district || _vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.region))]) : _vm._e(), _vm._v(" "), (_vm.site.state) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.region) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.state))]) : _vm._e(), _vm._v(" "), (_vm.site.country) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.region || _vm.site.state) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.country))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.site.sharers) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Sharers: ")]), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.site.sharers))])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d10f02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/SiteMap.vue
// module id = 1300
// module chunks = 0